import { cnl, isContainerValueType } from "c8-platform";
import { useFormStore, useStatefulFormField } from "csi/middleware/form/index";

/**
 * return goToDialogSave function for `SingleSelect` and `MultiSelect` components
 * used in `RefContainer` and `Ref` for "Go To Dialog" to appear in select dropdown
 * */
export const useGoToDialogSave = (): (urls: cnl[]) => void => {
	const formStore = useFormStore();
	const field = useStatefulFormField();
	const isContainer = isContainerValueType(field.valueType);

	const goToDialogSave = (urls: cnl[]): void => {
		const finalUrls = isContainer ? urls : urls[0];
		formStore?.handleFieldChange(null, field, finalUrls);
	};

	return goToDialogSave;
};
